const waterMeterManagementmRouter = {
  path: '/property',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'waterMeter',
      name: 'waterMeter',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterManagement/index.vue'),
      meta: {
        keepAlive: true,
        title: '水表管理',
      },
    },
    {
      path: 'waterPriceSetting',
      name: 'waterPriceSetting',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterPriceSetting/index.vue'),
      meta: {
        keepAlive: true,
        title: '片区水价设置',
      },
    },
    {
      path: 'waterPriceDetail',
      name: 'waterPriceDetail',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterPriceSetting/detail.vue'),
      meta: {
        keepAlive: true,
        title: '查看水价详情',
      },
    },
    {
      path: 'waterPriceAudit',
      name: 'waterPriceAudit',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterPriceSetting/detail.vue'),
      meta: {
        keepAlive: true,
        title: '审核片区水价',
      },
    },
    {
      path: 'waterMeterAudit',
      name: 'waterMeterAudit',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterAudit/index.vue'),
      meta: {
        keepAlive: true,
        title: '水表审核',
      },
    },
    {
      path: 'waterMeterAuditDetail',
      name: 'waterMeterAuditDetail',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterAudit/detail.vue'),
      meta: {
        keepAlive: true,
        title: '水表审核',
      },
    },
    {
      path: 'waterAuditDetail',
      name: 'waterAuditDetail',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterAudit/detail.vue'),
      meta: {
        keepAlive: true,
        title: '审核详情',
      },
    },
    {
      path: 'waterMeterReading',
      name: 'waterMeterReading',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterReading/index.vue'),
      meta: {
        keepAlive: true,
        title: '水表抄表管理',
      },
    },

    {
      path: 'waterMeterReadDetail',
      name: 'waterMeterReadDetail',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterReading/detail.vue'),
      meta: {
        keepAlive: true,
        title: '水表抄表详情',
      },
    },
    {
      path: 'waterMeterReadRegister',
      name: 'waterMeterReadRegister',
      component: () =>
        import('@/pages/property/energyCibsynption/waterMeter/waterMeterReading/register.vue'),
      meta: {
        keepAlive: true,
        title: '水表抄表登记',
      },
    },
  ],
};
export default waterMeterManagementmRouter;
